import './StickyHeader.scss';
import React from 'react';
import classNames from 'classnames';

interface Props {
    children: React.ReactNode;
    classNameRoot: string;
}

const StickHeader = ({ children, classNameRoot }: Props) => {
    return <div className={classNames('header', classNameRoot)}>{children}</div>;
};

export default StickHeader;
